import { createAction } from '@reduxjs/toolkit';

import {
  CONVERSION_TOOL_MAPPING_EDIT_RESET,
  CONVERSION_TOOL_MAPPING_EDIT_START,
  CONVERSION_TOOL_MAPPING_EDIT_SUCCESS,
  CONVERSION_TOOL_MAPPING_EDIT_FAILURE,
  CONVERSION_TOOL_MAPPING_FETCH_START,
  CONVERSION_TOOL_MAPPING_FETCH_FAILURE,
  CONVERSION_TOOL_MAPPING_FETCH_SUCCESS,
} from './conversionToolMappingEdit.const';

export const conversionToolMappingEditResetAction = createAction(
  CONVERSION_TOOL_MAPPING_EDIT_RESET
);

export const conversionToolMappingEditStartAction = createAction(
  CONVERSION_TOOL_MAPPING_EDIT_START
);
export const conversionToolMappingEditSuccessAction = createAction(
  CONVERSION_TOOL_MAPPING_EDIT_SUCCESS
);
export const conversionToolMappingEditFailureAction = createAction(
  CONVERSION_TOOL_MAPPING_EDIT_FAILURE
);

export const conversionToolMappingFetchStartAction = createAction(
  CONVERSION_TOOL_MAPPING_FETCH_START
);
export const conversionToolMappingFetchSuccessAction = createAction(
  CONVERSION_TOOL_MAPPING_FETCH_SUCCESS
);
export const conversionToolMappingFetchFailureAction = createAction(
  CONVERSION_TOOL_MAPPING_FETCH_FAILURE
);
